{
  "UnifiedNavigation": "在 Experience Cloud 盡情探索",
  "adobeExperienceCloudNoOrgsSelect": "選取其他組織帳戶",
  "help": "說明",
  "profile": "個人資料",
  "searchButton": "搜尋",
  "sidenavMenuCloseTooltip": "關閉選單",
  "sidenavMenuOpenTooltip": "開啟選單",
  "solutionSwitcher": "切換至其他解決方案",
  "toggleSideNav": "切換側面導覽功能表"
}
